export default class Scene {
  constructor (info, clickareas, beam, outlines, position) {
    this.info = info
    this.clickareas = clickareas
    this.beam = beam
    this.outlines = outlines
    this.position = position
  }
}
